import { mobxSet } from '@src/slide/infrastructure/module/independent/assert/get-set';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { GraphType } from '@src/slide/infrastructure/module/dependent/shape-info/constant';
import { AutoFitType } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/text-style-type';
import { dispatchResizeEvent } from '@frame-m/components/utils/dispatchResizeEvent';
import MobilePanel from '@com-m/tool-bar-m/MobilePanel';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import { ImageActionSheetOptionID } from '@src/slide/application/service/mobile-action-sheet-service/core/enum';
import { getToggleStatusByType, ToggleType } from '@src/slide/infrastructure/module/dependent/config/toggle-config';
import { MobileConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import DocsConfig from '@tencent/docs-config';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

const closeAddPanel = () => {
    const serviceLayer = getAppServices().editableServiceLayer;

    if (serviceLayer?.mobileToolbarEditManager?.editPanelShowState) {
        serviceLayer.mobileToolbarEditManager.closeEditPanel();
    }
};

// 处理加号面板的一系列点按事件
export const addPanelHandlerMap = {
    [ActionType.AI_GENERATE_PAGE_MOBILE]() {
        getAppServices().editableServiceLayer?.aiFloatManager?.triggerGeneratePageMobile({});
        tdw({
            opername: TDWOperationType.DOC_PPT_AI,
            module: TDWModuleType.PAGE_CREATE,
            action: TDWActionType.AI_CLK,
            ver5: TDWModuleType.MOBILE,
            ver6: '0',
        });
        closeAddPanel();
    },
    [ActionType.INSERT_TEXT]() {
        getAppServices().viewableServiceLayer.selectionService.selectedElements.clear();
        // 为了防止连续点击生成空文本框，每次点击前先进行失去焦点操作，提前触发空文本框的删除
        const current = {
            left: (getAppServices().getUiDataService().presentation.props.slideWidth / 2) - 200,
            top: (getAppServices().getUiDataService().presentation.props.slideHeight / 2) - 80,
        };
        const model = {
            style: {
                position: 'absolute',
                left: current.left,
                top: current.top,
                bgShape: GraphType.RECT,
                width: 400,
                height: 160,
            },
            subType: 1,
        };
        const extraInfo = {
            textBodyStyle: {
                autoFitType: AutoFitType.SHAPE_AUTO_FIT,
            },
        };
        const { currentSlideIndex, slides } = getAppServices().viewableServiceLayer.selectionService;
        const slideModel = slides[currentSlideIndex];
        if (slideModel) {
            slideModel.addElement([UIModelType.SHAPE], [model], [extraInfo]);
            const currentSlideChild = getAppServices().viewableServiceLayer.selectionService.currentSlide?.children
                || [];
            const shape = currentSlideChild.length && currentSlideChild[currentSlideChild.length - 1];
            shape && mobxSet(shape, 'initFocus', true);
            dispatchResizeEvent({ scrollCenter: true }); // 插入文本框后，使页面滚动到画布中心

            // 新交互，创建后直接进入编辑态
            if (shape) {
                (shape as IShapeModel).editorInstance?.setFocus();
            }
            closeAddPanel();
        }
    },
    [ActionType.INSERT_SHAPE]() {
        const textEditor = getAppServices().viewableServiceLayer.editorInstanceService.getEditorInstance();
        // 触发当前正在编辑的文本框失焦
        textEditor?.triggerBlur();
        getAppServices().viewableServiceLayer.selectionService.selectedElements.clear();
        this.mobilePanel = MobilePanel.createMenu({
            preferredHeight: window.innerHeight / 3 * 2,
        });
        this.mobilePanel.show();
        closeAddPanel();
    },
    [ActionType.INSERT_PHOTO_PICTURE]() {
        if (getToggleStatusByType(ToggleType.TDOCS_PICTURE_AUDIO_AND_VIDEO_SWITCH, true)
            && (DocsConfig.getInstance().getConfig(MobileConfig.insertNewPictureAudioVideo) ?? false)) {
            getMobileActionSheetService()?.then((service) => {
                service.imageActionSheet.callActionSheet([
                    ImageActionSheetOptionID.FromTencentDocument,
                    ImageActionSheetOptionID.FromLocalFile,
                ]);
            });
        } else {
            getMobileActionSheetService()?.then((service) => {
                service.imageActionSheet.callActionDirect(ImageActionSheetOptionID.FromPhotoAlbum);
            });
        }
        closeAddPanel();
    },
    [ActionType.INSERT_SHOOT]() {
        getMobileActionSheetService()?.then((service) => {
            service.imageActionSheet.callActionDirect(ImageActionSheetOptionID.Camera);
        });
        closeAddPanel();
    },
};

function getMobileActionSheetService() {
    return getAppServices().editableServiceLayer?.mobileActionSheetService?.promise();
}

function getAppServices(): IMobileEditorAppServices {
    return AppServiceProvider.getInstance().getAppServices() as IMobileEditorAppServices;
}
